import * as styles from './styles';
import FocusableButton from '@components/FocusableButton';
import { usePatientNameContext } from '@context/PatientName';
import { NAME_COMPLETE_BUTTON } from '../../../focuskey';

const ButtonContainer = () => {
  const { validateEmptyValue } = usePatientNameContext();

  return (
    <div css={styles.buttonContainer}>
      <FocusableButton focusKey={NAME_COMPLETE_BUTTON} onEnterPress={validateEmptyValue}>
        입력 완료
      </FocusableButton>
    </div>
  );
};

export default ButtonContainer;
